import {Dispatch} from 'react';
import {FrameAction} from '@mc/react-frame';

/**
 * Akce specifické pro mapový zobrazovač.
 */
export interface ViewerActions {
    // Pro budoucí použití.
}

/**
 * Vytvoří akce specifické pro mapový zobrazovač.
 *
 * @param dispatch - Dispatcher akcí.
 * @return Implementace akcí.
 * @ignore
 */
export const createViewerActions = (dispatch: Dispatch<FrameAction>): ViewerActions => ({
    // Pro budoucí použití.
});
